import { render } from "./DeleteDrConfirmationPopup.vue?vue&type=template&id=88783616&scoped=true"
import script from "./DeleteDrConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./DeleteDrConfirmationPopup.vue?vue&type=script&lang=js"

import "./DeleteDrConfirmationPopup.vue?vue&type=style&index=0&id=88783616&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88783616"]])

export default __exports__